<template>
  <div class="pa-10">
    <CompanyFeedbackDataTable />
  </div>
</template>

<script>
import CompanyFeedbackDataTable from "@/components/Utils/CompanyFeedbackDataTable.vue";

export default {
  components: {
    CompanyFeedbackDataTable,
  },
  created() {
    if (this.$store.state.expiryDate < Date.now()) {
      this.$store.dispatch("setUser", null);
      this.$store.dispatch("setIsAuthenticated", 0);
      this.render = true;
      this.$router.push("/");
    }
  },
  data: () => ({
    typeData: [],
    action: null,
    reload: false,
  }),
  methods: {},
};
</script>

<style></style>
